import { useState, useRef, useEffect } from "react";
import TEAS_FALLBACK from "./teas.json";

// Google Sheets live database — your Apps Script web app URL
const TEA_SHEET_API = "https://script.google.com/macros/s/AKfycbyyHS1P1djydyTrsZj_mrgKDfnvRk9VKs4gq7ZI8GoFkcwjeeQ7AMcBJNSJ2p4ccqPq/exec";

// ── LANGUAGE STRINGS ────────────────────────────────────────────────
const LANG = {
  en: {
    appSub: "30 TEAS · BREW · LOG · EXPLORE",
    brewingToday: "What are you brewing today?",
    searchPlaceholder: "Search teas, flavors, origins, history…",
    teasFound: (n) => `${n} tea${n !== 1 ? "s" : ""} found`,
    all: "All",
    brew: "brew", history: "history", tips: "tips",
    leaves: "Leaves", water: "Water", temp: "Temp", fridge: "Fridge",
    steepingTimer: "Steeping Timer",
    infusion: (i, t) => `Infusion ${i}: ${t}`,
    infusionOf: (i, n) => `Infusion ${i} of ${n}`,
    logSession: "📓 Log This Session",
    originHistory: "Origin & History",
    masterTips: "Master Tips & Tricks",
    logTitle: "📓 Log Tea Session",
    teaPhoto: "TEA PHOTO",
    uploadPhoto: "Upload a photo of your tea",
    tapToBrowse: "Tap to browse · Camera supported on mobile",
    tapToChange: "Tap to change",
    teaName: "TEA NAME",
    teaNamePlaceholder: "e.g. Da Hong Pao",
    date: "DATE", method: "METHOD",
    methodPlaceholder: "Gong Fu, Western…",
    liquorColor: "LIQUOR COLOR", body: "BODY", clarity: "CLARITY",
    aroma: "AROMA (multi-select)", taste: "TASTE (multi-select)", finish: "FINISH",
    rating: "RATING", tastingNotes: "TASTING NOTES",
    tastingPlaceholder: "Describe what you experience — taste, aroma, body, lingering notes…",
    saveDiary: "Save to Tea Diary",
    diaryTitle: "📓 Tea Diary",
    sessions: (n) => `${n} session${n !== 1 ? "s" : ""} logged`,
    newEntry: "+ New",
    emptyDiary: "Your tea diary is empty.",
    emptyDiarySub: "Log your first session to begin.",
    tastingNotesLabel: "TASTING NOTES",
    deleteEntry: "Delete Entry",
    backDiary: "‹ Diary",
    backTeas: "‹ All Teas",
    pause: "Pause", start: "Start", done: "Done", reset: "Reset",
    open: "Open",
    suggestTitle: "💌 Suggest a Tea",
    suggestSub: "Help us grow the library",
    yourName: "YOUR NAME (optional)",
    namePlaceholder: "Tea lover",
    teaSuggest: "TEA TO SUGGEST",
    teaSuggestPlaceholder: "e.g. Bai Ji Guan, Lishan High Mountain…",
    whySuggest: "WHY DO YOU LOVE IT?",
    whyPlaceholder: "Tell us about this tea — flavor, story, why it deserves a place here…",
    yourEmail: "YOUR EMAIL (optional, for follow-up)",
    emailPlaceholder: "you@example.com",
    sendSuggestion: "Send Suggestion",
    sending: "Sending…",
    sent: "✓ Thank you! We'll review your suggestion.",
    sendError: "Failed to send. Please try again.",
    navTeas: "Teas", navLog: "Log", navDiary: "Diary", navSuggest: "Suggest",
    colorOpts: ["Pale Yellow","Golden","Amber","Copper","Orange","Red-Brown","Dark Brown","Purple","Green"],
    bodyOpts: ["Light","Light-Medium","Medium","Medium-Full","Full","Heavy"],
    clarityOpts: ["Crystal Clear","Clear","Slight Haze","Hazy","Cloudy"],
    aromaOpts: ["Floral","Fruity","Vegetal","Roasted","Earthy","Spicy","Mineral","Sweet","Smoky","Umami","Honey","Citrus"],
    tasteOpts: ["Sweet","Bitter","Astringent","Umami","Sour","Mineral","Malty","Smoky","Floral"],
    finishOpts: ["Short","Medium","Long","Very Long","Cooling","Warming"],
  },
  th: {
    appSub: "30 ชา · ชง · บันทึก · สำรวจ",
    brewingToday: "วันนี้คุณชงชาอะไร?",
    searchPlaceholder: "ค้นหาชา รสชาติ แหล่งกำเนิด ประวัติ…",
    teasFound: (n) => `พบ ${n} ชา`,
    all: "ทั้งหมด",
    brew: "ชง", history: "ประวัติ", tips: "เคล็ดลับ",
    leaves: "ใบชา", water: "น้ำ", temp: "อุณหภูมิ", fridge: "ตู้เย็น",
    steepingTimer: "ตั้งเวลาชง",
    infusion: (i, t) => `ครั้งที่ ${i}: ${t}`,
    infusionOf: (i, n) => `ครั้งที่ ${i} จาก ${n}`,
    logSession: "📓 บันทึกการชงนี้",
    originHistory: "แหล่งกำเนิดและประวัติ",
    masterTips: "เคล็ดลับจากผู้เชี่ยวชาญ",
    logTitle: "📓 บันทึกการชงชา",
    teaPhoto: "รูปภาพชา",
    uploadPhoto: "อัพโหลดรูปภาพชาของคุณ",
    tapToBrowse: "แตะเพื่อเลือกรูป · รองรับกล้องบนมือถือ",
    tapToChange: "แตะเพื่อเปลี่ยน",
    teaName: "ชื่อชา",
    teaNamePlaceholder: "เช่น ต้าหงเผา",
    date: "วันที่", method: "วิธีชง",
    methodPlaceholder: "กงฟู, เวสเทิร์น…",
    liquorColor: "สีน้ำชา", body: "ความเข้มข้น", clarity: "ความใส",
    aroma: "กลิ่น (เลือกได้หลายอย่าง)", taste: "รสชาติ (เลือกได้หลายอย่าง)", finish: "รสหลัง",
    rating: "คะแนน", tastingNotes: "บันทึกการชิม",
    tastingPlaceholder: "บรรยายสิ่งที่คุณรู้สึก — รสชาติ กลิ่น ความเข้มข้น รสที่ค้างอยู่…",
    saveDiary: "บันทึกลงไดอารี่ชา",
    diaryTitle: "📓 ไดอารี่ชา",
    sessions: (n) => `บันทึกแล้ว ${n} ครั้ง`,
    newEntry: "+ บันทึกใหม่",
    emptyDiary: "ไดอารี่ชาของคุณยังว่างเปล่า",
    emptyDiarySub: "เริ่มบันทึกครั้งแรกของคุณ",
    tastingNotesLabel: "บันทึกการชิม",
    deleteEntry: "ลบรายการนี้",
    backDiary: "‹ ไดอารี่",
    backTeas: "‹ ชาทั้งหมด",
    pause: "หยุด", start: "เริ่ม", done: "เสร็จ", reset: "รีเซ็ต",
    open: "เปิด",
    suggestTitle: "💌 แนะนำชา",
    suggestSub: "ช่วยเราขยายคลังชา",
    yourName: "ชื่อของคุณ (ไม่บังคับ)",
    namePlaceholder: "นักดื่มชา",
    teaSuggest: "ชาที่ต้องการแนะนำ",
    teaSuggestPlaceholder: "เช่น ไป๋จี๋กวน, ลีซาน…",
    whySuggest: "ทำไมคุณถึงชอบชานี้?",
    whyPlaceholder: "บอกเราเกี่ยวกับชานี้ รสชาติ เรื่องราว ทำไมมันถึงสมควรมีที่นี่…",
    yourEmail: "อีเมลของคุณ (ไม่บังคับ สำหรับติดตามผล)",
    emailPlaceholder: "you@example.com",
    sendSuggestion: "ส่งคำแนะนำ",
    sending: "กำลังส่ง…",
    sent: "✓ ขอบคุณ! เราจะพิจารณาคำแนะนำของคุณ",
    sendError: "ส่งไม่สำเร็จ กรุณาลองใหม่",
    navTeas: "ชา", navLog: "บันทึก", navDiary: "ไดอารี่", navSuggest: "แนะนำ",
    colorOpts: ["เหลืองอ่อน","ทอง","อำพัน","ทองแดง","ส้ม","น้ำตาลแดง","น้ำตาลเข้ม","ม่วง","เขียว"],
    bodyOpts: ["เบา","เบา-กลาง","กลาง","กลาง-หนัก","หนัก","หนักมาก"],
    clarityOpts: ["ใสมาก","ใส","ขุ่นเล็กน้อย","ขุ่น","ขุ่นมาก"],
    aromaOpts: ["ดอกไม้","ผลไม้","ผัก","คั่ว","ดิน","เครื่องเทศ","แร่ธาตุ","หวาน","รมควัน","อูมามิ","น้ำผึ้ง","ส้ม"],
    tasteOpts: ["หวาน","ขม","ฝาด","อูมามิ","เปรี้ยว","แร่ธาตุ","มอลต์","รมควัน","ดอกไม้"],
    finishOpts: ["สั้น","กลาง","ยาว","ยาวมาก","เย็น","อุ่น"],
  }
};

const CATEGORIES_EN = ["All","Oolong","White","Green","Black","Pu-erh","Yellow","Herbal","Scented","Specialty"];
const CATEGORIES_TH = ["ทั้งหมด","อูลอง","ขาว","เขียว","ดำ","ผูเอ๋อร์","เหลือง","สมุนไพร","มีกลิ่น","พิเศษ"];
const CAT_MAP = { "ทั้งหมด":"All","อูลอง":"Oolong","ขาว":"White","เขียว":"Green","ดำ":"Black","ผูเอ๋อร์":"Pu-erh","เหลือง":"Yellow","สมุนไพร":"Herbal","มีกลิ่น":"Scented","พิเศษ":"Specialty" };

// EmailJS config — replace with your own values from emailjs.com
const EMAILJS_SERVICE_ID  = "service_br6x56e";
const EMAILJS_TEMPLATE_ID = "template_wsm9mok";
const EMAILJS_PUBLIC_KEY  = "KiWPrsnVYBgozKwwm";

const GOLD="#D4962A",TEXT="#f0e6d0",MUTED="#9a8060",CARD="rgba(255,255,255,.04)",BORDER="rgba(255,255,255,.08)";
const btnS=(a)=>({background:a?GOLD:"transparent",color:a?"#12100A":MUTED,border:a?"none":`1px solid ${BORDER}`,padding:"6px 14px",borderRadius:20,cursor:"pointer",fontFamily:"Georgia,serif",fontSize:11,fontWeight:a?"bold":"normal",transition:"all .2s"});
const inpS={width:"100%",background:CARD,border:`1px solid ${BORDER}`,borderRadius:10,padding:"9px 13px",color:TEXT,fontFamily:"Georgia,serif",fontSize:13,boxSizing:"border-box"};

function Steam(){
  return(<div style={{position:"relative",height:46,width:80,margin:"0 auto"}}>
    {[0,1,2].map(i=><div key={i} style={{position:"absolute",bottom:0,left:`${18+i*22}px`,width:3,height:34,background:"linear-gradient(to top,rgba(255,255,255,.5),transparent)",borderRadius:10,animation:`steam ${1.4+i*.3}s ease-in-out infinite`,animationDelay:`${i*.35}s`}}/>)}
    <style>{`@keyframes steam{0%{transform:translateY(0) scaleX(1);opacity:.7}50%{transform:translateY(-16px) scaleX(1.5);opacity:.3}100%{transform:translateY(-34px) scaleX(.8);opacity:0}}@keyframes fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@keyframes slideIn{from{opacity:0;transform:translateX(-12px)}to{opacity:1;transform:translateX(0)}}@keyframes timerPulse{0%,100%{box-shadow:0 0 0 0 rgba(212,150,42,.4)}50%{box-shadow:0 0 0 14px rgba(212,150,42,0)}}`}</style>
  </div>);
}

function Timer({seconds,label,onComplete,L}){
  const [rem,setRem]=useState(seconds),[running,setRunning]=useState(false),[done,setDone]=useState(false),ref=useRef();
  useEffect(()=>{if(running&&rem>0){ref.current=setInterval(()=>setRem(r=>{if(r<=1){clearInterval(ref.current);setRunning(false);setDone(true);if(onComplete)onComplete();return 0;}return r-1;}),1000);}return()=>clearInterval(ref.current);},[running]);
  const mins=Math.floor(rem/60),secs=rem%60,prog=1-rem/seconds;
  const reset=()=>{setRem(seconds);setRunning(false);setDone(false);};
  return(<div style={{textAlign:"center",padding:"10px 0"}}>
    <div style={{width:106,height:106,borderRadius:"50%",margin:"0 auto 9px",background:`conic-gradient(${GOLD} ${prog*360}deg,rgba(255,255,255,.07) 0deg)`,display:"flex",alignItems:"center",justifyContent:"center",animation:running?"timerPulse 2s ease-in-out infinite":"none"}}>
      <div style={{width:84,height:84,borderRadius:"50%",background:"#12100A",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <span style={{fontFamily:"'Courier New',monospace",fontSize:19,color:done?GOLD:TEXT,fontWeight:"bold"}}>{done?"✓":`${mins}:${String(secs).padStart(2,"0")}`}</span>
      </div>
    </div>
    <p style={{color:MUTED,fontSize:10,margin:"0 0 8px",fontStyle:"italic"}}>{label}</p>
    <div style={{display:"flex",gap:7,justifyContent:"center"}}>
      <button onClick={()=>setRunning(r=>!r)} style={{background:running?"rgba(212,150,42,.15)":GOLD,border:running?`1px solid ${GOLD}`:"none",color:running?GOLD:"#12100A",padding:"7px 17px",borderRadius:20,cursor:"pointer",fontFamily:"Georgia,serif",fontSize:12,fontWeight:"bold"}}>{running?L.pause:done?L.done:L.start}</button>
      <button onClick={reset} style={{background:"transparent",border:`1px solid ${BORDER}`,color:MUTED,padding:"7px 13px",borderRadius:20,cursor:"pointer",fontSize:11}}>{L.reset}</button>
    </div>
  </div>);
}

export default function App(){
  const [lang,setLang]=useState(()=>localStorage.getItem("tmLang")||"en");

  // Tea database: fetch live from Google Sheets, fall back to cached/bundled data
  const [TEAS_RAW,setTeasRaw]=useState(()=>{
    try{
      const cached=localStorage.getItem("tmTeasCache");
      return cached?JSON.parse(cached):TEAS_FALLBACK;
    }catch{return TEAS_FALLBACK;}
  });
  const [teasLoading,setTeasLoading]=useState(true);
  const [teasSource,setTeasSource]=useState("cache"); // cache | live | fallback

  useEffect(()=>{
    fetch(TEA_SHEET_API)
      .then(r=>r.json())
      .then(data=>{
        if(Array.isArray(data)&&data.length>0){
          setTeasRaw(data);
          setTeasSource("live");
          try{localStorage.setItem("tmTeasCache",JSON.stringify(data));}catch{}
        }
      })
      .catch(()=>{
        // Network/CORS failure — keep using cache or bundled fallback
        setTeasSource(s=>s==="cache"?"cache":"fallback");
      })
      .finally(()=>setTeasLoading(false));
  },[]);

  const L=LANG[lang];
  const toggleLang=()=>{const nl=lang==="en"?"th":"en";setLang(nl);localStorage.setItem("tmLang",nl);};

  const [view,setView]=useState("home");
  const [selTea,setSelTea]=useState(null);
  const [selMethod,setSelMethod]=useState(null);
  const [tab,setTab]=useState("brew");
  const [infIdx,setInfIdx]=useState(0);
  const [search,setSearch]=useState("");
  const [cat,setCat]=useState("All");
  const [diary,setDiary]=useState(()=>{try{return JSON.parse(localStorage.getItem("tmD3")||"[]")}catch{return[]}});
  const [entry,setEntry]=useState({tea:"",date:new Date().toISOString().slice(0,10),method:"",color:"",body:"",clarity:"",aroma:[],taste:[],finish:"",overall:0,notes:"",photo:null});
  const [viewEntry,setViewEntry]=useState(null);
  const [suggest,setSuggest]=useState({name:"",tea:"",why:"",email:""});
  const [suggestStatus,setSuggestStatus]=useState("idle"); // idle | sending | sent | error
  const fileRef=useRef();

  const CATEGORIES = lang==="en" ? CATEGORIES_EN : CATEGORIES_TH;

  const saveDiary=(d)=>{setDiary(d);try{localStorage.setItem("tmD3",JSON.stringify(d))}catch{}};

  const teaObj=selTea?TEAS_RAW.find(t=>t.name===selTea):null;
  const methodObj=teaObj&&selMethod?teaObj.methods[selMethod]:null;

  const fmtSec=s=>{if(!s)return L.open;if(s>=3600)return`${s/3600}h`;if(s>=60)return`${Math.floor(s/60)}m${s%60?s%60+"s":""}`.trim();return`${s}s`;};

  const filtered=TEAS_RAW.filter(t=>{
    const q=search.toLowerCase();
    const catEn=lang==="en"?cat:(CAT_MAP[cat]||cat);
    const ms=!q||t.name.toLowerCase().includes(q)||(t.historyTH&&t.historyTH.toLowerCase().includes(q))||t.category.toLowerCase().includes(q)||t.flavorProfile.some(f=>f.toLowerCase().includes(q))||(t.flavorProfileTH&&t.flavorProfileTH.some(f=>f.toLowerCase().includes(q)))||t.origin.toLowerCase().includes(q)||t.history.toLowerCase().includes(q);
    return ms&&(catEn==="All"||t.category===catEn);
  });

  const handlePhoto=(e)=>{
    const f=e.target.files[0];if(!f)return;
    const reader=new FileReader();
    reader.onload=ev=>{
      const img=new Image();
      img.onload=()=>{
        const MAX=800,Q=0.75;
        let w=img.width,h=img.height;
        if(w>MAX){h=Math.round(h*MAX/w);w=MAX;}
        const canvas=document.createElement("canvas");
        canvas.width=w;canvas.height=h;
        canvas.getContext("2d").drawImage(img,0,0,w,h);
        setEntry(n=>({...n,photo:canvas.toDataURL("image/jpeg",Q)}));
      };
      img.src=ev.target.result;
    };
    reader.readAsDataURL(f);
  };

  const addEntry=()=>{
    if(!entry.tea)return;
    saveDiary([{...entry,id:Date.now(),timestamp:new Date().toISOString()},...diary]);
    setEntry({tea:"",date:new Date().toISOString().slice(0,10),method:"",color:"",body:"",clarity:"",aroma:[],taste:[],finish:"",overall:0,notes:"",photo:null});
    setView("diary");
  };

  const sendSuggestion=async()=>{
    if(!suggest.tea.trim())return;
    setSuggestStatus("sending");
    try{
      // Load EmailJS dynamically
      if(!window.emailjs){
        await new Promise((res,rej)=>{
          const s=document.createElement("script");
          s.src="https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js";
          s.onload=res; s.onerror=rej;
          document.head.appendChild(s);
        });
      }
      // v4 SDK requires init with an options object, and publicKey passed per-call as a safety net
      window.emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
      await window.emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
        from_name: suggest.name||"Anonymous",
        tea_name: suggest.tea,
        reason: suggest.why,
        reply_to: suggest.email||"no-reply",
        app_name: "Tea Master"
      }, { publicKey: EMAILJS_PUBLIC_KEY });
      setSuggestStatus("sent");
      setSuggest({name:"",tea:"",why:"",email:""});
    }catch(e){
      console.error(e);
      setSuggestStatus("error");
    }
  };

  const nav=(id,icon,label)=>(
    <button onClick={()=>{setView(id);if(id==="home"){setSelTea(null);setSelMethod(null);}setSuggestStatus("idle");}} style={{flex:1,background:"transparent",border:"none",borderTop:view===id?`2px solid ${GOLD}`:"2px solid transparent",color:view===id?GOLD:MUTED,padding:"10px 2px",cursor:"pointer",fontFamily:"Georgia,serif",fontSize:9,display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
      <span style={{fontSize:16}}>{icon}</span>{label}
    </button>
  );

  const tName=(t)=>t.name;
  const tOrigin=(t)=>lang==="en"?t.origin:(t.originTH||t.origin);
  const tHistory=(t)=>lang==="en"?t.history:(t.historyTH||t.history);
  const tTips=(t)=>lang==="en"?t.tips:(t.tipsTH||t.tips);
  const tFlavors=(t)=>lang==="en"?t.flavorProfile:(t.flavorProfileTH||t.flavorProfile);
  const mNotes=(m)=>lang==="en"?m.notes:(m.notesTH||m.notes);
  const mSteps=(m)=>lang==="en"?m.steps:(m.stepsTH||m.steps);

  return(
    <div style={{background:"linear-gradient(135deg,#0f0a04 0%,#1a1208 55%,#0d0d08 100%)",minHeight:"100vh",maxWidth:430,margin:"0 auto",color:TEXT,fontFamily:"Georgia,serif"}}>

      {/* Header */}
      <div style={{padding:"14px 16px 10px",background:"rgba(0,0,0,.35)",borderBottom:`1px solid ${BORDER}`,position:"sticky",top:0,zIndex:10,backdropFilter:"blur(20px)"}}>
        <div style={{display:"flex",alignItems:"center",gap:9}}>
          <span style={{fontSize:22}}>🍵</span>
          <div style={{flex:1}}>
            <h1 style={{margin:0,fontSize:17,fontWeight:"normal",letterSpacing:2,color:GOLD}}>茶 TEA MASTER</h1>
            <p style={{margin:0,fontSize:9,color:MUTED,letterSpacing:1,display:"flex",alignItems:"center",gap:5}}>
              {L.appSub}
              <span title={teasSource==="live"?"Synced with Google Sheets":teasSource==="cache"?"Using cached data":"Offline data"} style={{width:6,height:6,borderRadius:"50%",background:teasSource==="live"?"#6AAE69":teasSource==="cache"?GOLD:MUTED,display:"inline-block",flexShrink:0}}/>
            </p>
          </div>
          {/* Language toggle */}
          <button onClick={toggleLang} style={{background:`${GOLD}18`,border:`1px solid ${GOLD}40`,color:GOLD,borderRadius:18,padding:"5px 12px",cursor:"pointer",fontFamily:"Georgia,serif",fontSize:11,fontWeight:"bold",letterSpacing:1}}>
            {lang==="en"?"🇹🇭 ไทย":"🇬🇧 EN"}
          </button>
        </div>
      </div>

      <div style={{padding:16,paddingBottom:72,overflowY:"auto"}}>

        {/* HOME */}
        {view==="home"&&(
          <div style={{animation:"fadeIn .35s ease"}}>
            <div style={{textAlign:"center",margin:"12px 0 16px"}}><Steam/><p style={{color:MUTED,fontSize:11,fontStyle:"italic",margin:"4px 0 2px"}}>{new Date().toLocaleDateString(lang==="en"?"en-US":"th-TH",{weekday:"long",month:"long",day:"numeric"})}</p><h2 style={{margin:"2px 0 0",fontSize:16,fontWeight:"normal"}}>{L.brewingToday}</h2></div>

            <div style={{position:"relative",marginBottom:11}}>
              <span style={{position:"absolute",left:13,top:"50%",transform:"translateY(-50%)",color:MUTED,fontSize:13}}>🔍</span>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder={L.searchPlaceholder} style={{...inpS,paddingLeft:36,borderRadius:22}}/>
              {search&&<button onClick={()=>setSearch("")} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:MUTED,cursor:"pointer",fontSize:14,lineHeight:1}}>✕</button>}
            </div>

            <div style={{display:"flex",gap:5,overflowX:"auto",paddingBottom:8,marginBottom:10,scrollbarWidth:"none"}}>
              {CATEGORIES.map(c=><button key={c} onClick={()=>setCat(c)} style={{...btnS(cat===c),whiteSpace:"nowrap",padding:"5px 11px",flexShrink:0}}>{c}</button>)}
            </div>
            <p style={{color:MUTED,fontSize:10,margin:"0 0 9px"}}>{L.teasFound(filtered.length)}</p>

            {filtered.length===0?(
              <div style={{textAlign:"center",padding:"36px 20px",color:MUTED}}><div style={{fontSize:32,marginBottom:9}}>🔍</div><p style={{margin:0}}>"{search}"</p></div>
            ):(
              <div style={{display:"grid",gap:9}}>
                {filtered.map((t,i)=>(
                  <button key={t.name} onClick={()=>{setSelTea(t.name);setSelMethod(null);setView("tea");setTab("brew");setInfIdx(0);}} style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:13,padding:13,cursor:"pointer",textAlign:"left",color:TEXT,display:"flex",alignItems:"center",gap:11,animation:`slideIn ${Math.min(.3+i*.03,.6)}s ease`,transition:"border-color .2s",width:"100%"}} onMouseEnter={e=>e.currentTarget.style.borderColor=GOLD} onMouseLeave={e=>e.currentTarget.style.borderColor=BORDER}>
                    <div style={{width:42,height:42,borderRadius:9,background:`${t.color}22`,border:`1px solid ${t.color}38`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{t.emoji}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:"bold",fontSize:13,marginBottom:2}}>{tName(t)}</div>
                      <div style={{fontSize:10,color:MUTED,marginBottom:4}}><span style={{background:`${t.color}18`,border:`1px solid ${t.color}32`,color:t.color,padding:"1px 7px",borderRadius:7,fontSize:9}}>{t.category}</span> · {tOrigin(t).split(",")[0]}</div>
                      <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>
                        {tFlavors(t).slice(0,3).map(f=><span key={f} style={{background:`${GOLD}10`,border:`1px solid ${GOLD}25`,color:GOLD,fontSize:9,padding:"1px 7px",borderRadius:8}}>{f}</span>)}
                      </div>
                    </div>
                    <span style={{color:MUTED,fontSize:15}}>›</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* TEA DETAIL */}
        {view==="tea"&&teaObj&&(
          <div style={{animation:"fadeIn .3s ease"}}>
            <button onClick={()=>setView("home")} style={{background:"none",border:"none",color:MUTED,cursor:"pointer",fontSize:12,marginBottom:12,display:"flex",alignItems:"center",gap:5}}>{L.backTeas}</button>
            <div style={{textAlign:"center",marginBottom:16}}>
              <div style={{fontSize:42,marginBottom:4}}>{teaObj.emoji}</div>
              <h2 style={{margin:"0 0 2px",fontSize:21,fontWeight:"normal",color:GOLD}}>{tName(teaObj)}</h2>
              <p style={{margin:"0 0 7px",color:MUTED,fontSize:11}}>{teaObj.category} · {tOrigin(teaObj)}</p>
              <div style={{display:"flex",gap:4,justifyContent:"center",flexWrap:"wrap"}}>
                {tFlavors(teaObj).map(f=><span key={f} style={{background:`${teaObj.color}1A`,border:`1px solid ${teaObj.color}38`,color:teaObj.color,fontSize:10,padding:"2px 9px",borderRadius:10}}>{f}</span>)}
              </div>
            </div>

            <div style={{display:"flex",gap:5,marginBottom:14,flexWrap:"wrap"}}>
              {[L.brew,L.history,L.tips].map(t=><button key={t} onClick={()=>setTab(t)} style={{...btnS(tab===t),fontSize:11,padding:"6px 13px"}}>{t}</button>)}
            </div>

            {tab===L.brew&&(
              <div>
                <div style={{display:"flex",gap:5,marginBottom:13,flexWrap:"wrap"}}>
                  {Object.keys(teaObj.methods).map(m=><button key={m} onClick={()=>{setSelMethod(m);setInfIdx(0);}} style={{...btnS(selMethod===m),fontSize:11}}>{m}</button>)}
                </div>
                {methodObj&&(
                  <div style={{animation:"fadeIn .3s ease"}}>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:7,marginBottom:13}}>
                      {[{l:L.leaves,v:`${methodObj.grams}g`,i:"🍃"},{l:L.water,v:`${methodObj.waterMl}ml`,i:"💧"},{l:L.temp,v:methodObj.tempC<10?L.fridge:`${methodObj.tempC}°C`,i:"🌡️"}].map(p=>(
                        <div key={p.l} style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:11,padding:"11px 7px",textAlign:"center"}}>
                          <div style={{fontSize:17}}>{p.i}</div>
                          <div style={{fontSize:16,fontWeight:"bold",color:GOLD,margin:"3px 0 2px"}}>{p.v}</div>
                          <div style={{fontSize:9,color:MUTED}}>{p.l}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:11,padding:13,marginBottom:11}}>
                      <p style={{margin:"0 0 7px",fontSize:11,color:MUTED,fontStyle:"italic"}}>{mNotes(methodObj)}</p>
                      <ol style={{margin:0,paddingLeft:15,fontSize:12,lineHeight:1.85,color:"#d4c8b0"}}>
                        {mSteps(methodObj).map((s,i)=><li key={i}>{s}</li>)}
                      </ol>
                    </div>
                    {methodObj.steepSec?.[0]&&(
                      <div style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:11,padding:13}}>
                        <h3 style={{margin:"0 0 3px",fontSize:12,color:TEXT,fontWeight:"normal"}}>{L.steepingTimer}</h3>
                        {methodObj.steepSec.length>1&&(
                          <div>
                            <p style={{margin:"0 0 8px",fontSize:10,color:MUTED}}>{L.infusionOf(infIdx+1,methodObj.steepSec.length)}</p>
                            <div style={{display:"flex",gap:4,marginBottom:8,flexWrap:"wrap"}}>
                              {methodObj.steepSec.map((s,i)=><button key={i} onClick={()=>setInfIdx(i)} style={{...btnS(infIdx===i),padding:"4px 9px",fontSize:9}}>#{i+1}·{fmtSec(s)}</button>)}
                            </div>
                          </div>
                        )}
                        <Timer key={`${selMethod}-${infIdx}`} seconds={methodObj.steepSec[infIdx]} label={L.infusion(infIdx+1,fmtSec(methodObj.steepSec[infIdx]))} onComplete={()=>{if(infIdx<methodObj.steepSec.length-1)setTimeout(()=>setInfIdx(i=>i+1),1500);}} L={L}/>
                      </div>
                    )}
                    <button onClick={()=>{setEntry(e=>({...e,tea:selTea,method:selMethod}));setView("log");}} style={{width:"100%",marginTop:11,background:GOLD,border:"none",color:"#12100A",padding:12,borderRadius:11,cursor:"pointer",fontFamily:"Georgia,serif",fontSize:13,fontWeight:"bold"}}>{L.logSession}</button>
                  </div>
                )}
              </div>
            )}

            {tab===L.history&&<div style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:11,padding:16,lineHeight:1.85,animation:"fadeIn .3s ease"}}><h3 style={{margin:"0 0 9px",color:GOLD,fontWeight:"normal",fontSize:16}}>{L.originHistory}</h3><p style={{margin:0,fontSize:12,color:"#d4c8b0"}}>{tHistory(teaObj)}</p></div>}

            {tab===L.tips&&(
              <div style={{animation:"fadeIn .3s ease"}}>
                <h3 style={{margin:"0 0 10px",color:GOLD,fontWeight:"normal"}}>{L.masterTips}</h3>
                {tTips(teaObj).map((tip,i)=>(
                  <div key={i} style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:11,padding:12,marginBottom:8,display:"flex",gap:9}}>
                    <span style={{color:GOLD,fontSize:13,flexShrink:0,marginTop:2}}>✦</span>
                    <p style={{margin:0,fontSize:12,lineHeight:1.75,color:"#d4c8b0"}}>{tip}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* LOG */}
        {view==="log"&&(
          <div style={{animation:"fadeIn .3s ease"}}>
            <h2 style={{margin:"0 0 15px",fontWeight:"normal",color:GOLD}}>{L.logTitle}</h2>
            <div style={{display:"grid",gap:12}}>
              <div>
                <label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5,letterSpacing:.5}}>{L.teaPhoto}</label>
                <div onClick={()=>fileRef.current.click()} style={{border:`2px dashed ${entry.photo?"transparent":BORDER}`,borderRadius:13,overflow:"hidden",cursor:"pointer",minHeight:145,display:"flex",alignItems:"center",justifyContent:"center",background:entry.photo?"none":CARD,position:"relative",transition:"border-color .2s"}} onMouseEnter={e=>!entry.photo&&(e.currentTarget.style.borderColor=GOLD)} onMouseLeave={e=>!entry.photo&&(e.currentTarget.style.borderColor=BORDER)}>
                  {entry.photo?(
                    <div style={{position:"relative",width:"100%"}}>
                      <img src={entry.photo} alt="tea" style={{width:"100%",height:180,objectFit:"cover",display:"block"}}/>
                      <button onClick={e=>{e.stopPropagation();setEntry(n=>({...n,photo:null}));}} style={{position:"absolute",top:8,right:8,background:"rgba(0,0,0,.65)",border:"none",color:"#fff",borderRadius:"50%",width:26,height:26,cursor:"pointer",fontSize:13,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                      <div style={{position:"absolute",bottom:8,left:8,background:"rgba(0,0,0,.6)",borderRadius:7,padding:"3px 9px",fontSize:10,color:GOLD}}>{L.tapToChange}</div>
                    </div>
                  ):(
                    <div style={{textAlign:"center",padding:18}}><div style={{fontSize:30,marginBottom:6}}>📷</div><p style={{margin:0,color:MUTED,fontSize:12}}>{L.uploadPhoto}</p><p style={{margin:"3px 0 0",color:MUTED,fontSize:10}}>{L.tapToBrowse}</p></div>
                  )}
                </div>
                <input ref={fileRef} type="file" accept="image/*" capture="environment" onChange={handlePhoto} style={{display:"none"}}/>
              </div>

              <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.teaName}</label><input value={entry.tea} onChange={e=>setEntry(n=>({...n,tea:e.target.value}))} placeholder={L.teaNamePlaceholder} list="tlst" style={inpS}/><datalist id="tlst">{TEAS_RAW.map(t=><option key={t.name} value={t.name}/>)}</datalist></div>

              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
                <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.date}</label><input type="date" value={entry.date} onChange={e=>setEntry(n=>({...n,date:e.target.value}))} style={inpS}/></div>
                <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.method}</label><input value={entry.method} onChange={e=>setEntry(n=>({...n,method:e.target.value}))} placeholder={L.methodPlaceholder} style={inpS}/></div>
              </div>

              {[{k:"color",l:L.liquorColor,o:L.colorOpts},{k:"body",l:L.body,o:L.bodyOpts},{k:"clarity",l:L.clarity,o:L.clarityOpts},{k:"finish",l:L.finish,o:L.finishOpts}].map(({k,l,o})=>(
                <div key={k}><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{l}</label><div style={{display:"flex",gap:4,flexWrap:"wrap"}}>{o.map(x=><button key={x} onClick={()=>setEntry(n=>({...n,[k]:x}))} style={{...btnS(entry[k]===x),padding:"5px 10px",fontSize:10}}>{x}</button>)}</div></div>
              ))}

              {[{k:"aroma",l:L.aroma,o:L.aromaOpts},{k:"taste",l:L.taste,o:L.tasteOpts}].map(({k,l,o})=>(
                <div key={k}><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{l}</label><div style={{display:"flex",gap:4,flexWrap:"wrap"}}>{o.map(x=><button key={x} onClick={()=>setEntry(n=>({...n,[k]:n[k].includes(x)?n[k].filter(i=>i!==x):[...n[k],x]}))} style={{...btnS(entry[k].includes(x)),padding:"5px 10px",fontSize:10}}>{x}</button>)}</div></div>
              ))}

              <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.rating}</label><div style={{display:"flex",gap:5}}>{[1,2,3,4,5].map(s=><button key={s} onClick={()=>setEntry(n=>({...n,overall:s}))} style={{background:"none",border:"none",fontSize:23,cursor:"pointer",opacity:entry.overall>=s?1:.22,filter:entry.overall>=s?"none":"grayscale(1)",transition:"all .15s"}}>⭐</button>)}</div></div>

              <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.tastingNotes}</label><textarea value={entry.notes} onChange={e=>setEntry(n=>({...n,notes:e.target.value}))} placeholder={L.tastingPlaceholder} style={{...inpS,minHeight:82,resize:"vertical"}}/></div>

              <button onClick={addEntry} style={{background:GOLD,border:"none",color:"#12100A",padding:12,borderRadius:11,cursor:"pointer",fontFamily:"Georgia,serif",fontSize:13,fontWeight:"bold"}}>{L.saveDiary}</button>
            </div>
          </div>
        )}

        {/* DIARY LIST */}
        {view==="diary"&&!viewEntry&&(
          <div style={{animation:"fadeIn .3s ease"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div><h2 style={{margin:0,fontWeight:"normal",color:GOLD}}>{L.diaryTitle}</h2><p style={{margin:"2px 0 0",fontSize:10,color:MUTED}}>{L.sessions(diary.length)}</p></div>
              <button onClick={()=>setView("log")} style={{background:GOLD,border:"none",color:"#12100A",padding:"7px 13px",borderRadius:18,cursor:"pointer",fontFamily:"Georgia,serif",fontSize:11,fontWeight:"bold"}}>{L.newEntry}</button>
            </div>
            {diary.length===0?(
              <div style={{textAlign:"center",padding:"44px 20px",color:MUTED}}><div style={{fontSize:38,marginBottom:10}}>📖</div><p style={{margin:"0 0 3px"}}>{L.emptyDiary}</p><p style={{fontSize:11,margin:0}}>{L.emptyDiarySub}</p></div>
            ):(
              <div style={{display:"grid",gap:10}}>
                {diary.map(e=>(
                  <button key={e.id} onClick={()=>setViewEntry(e)} style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:13,padding:13,cursor:"pointer",textAlign:"left",color:TEXT,transition:"border-color .2s",width:"100%"}} onMouseEnter={ev=>ev.currentTarget.style.borderColor=GOLD} onMouseLeave={ev=>ev.currentTarget.style.borderColor=BORDER}>
                    <div style={{display:"flex",gap:11,alignItems:"flex-start"}}>
                      {e.photo&&<img src={e.photo} alt="" style={{width:58,height:58,borderRadius:9,objectFit:"cover",flexShrink:0}}/>}
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}><span style={{fontWeight:"bold",fontSize:13}}>{e.tea}</span><span style={{fontSize:11}}>{"⭐".repeat(e.overall)}</span></div>
                        <p style={{margin:"0 0 5px",fontSize:10,color:MUTED}}>{e.date}{e.method?` · ${e.method}`:""}</p>
                        <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>{[e.color,e.body,e.finish].filter(Boolean).map((a,i)=><span key={i} style={{background:`${GOLD}12`,border:`1px solid ${GOLD}25`,color:GOLD,fontSize:9,padding:"1px 7px",borderRadius:7}}>{a}</span>)}</div>
                        {e.notes&&<p style={{margin:"5px 0 0",fontSize:10,color:"#b0a080",fontStyle:"italic",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.notes}</p>}
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* DIARY DETAIL */}
        {view==="diary"&&viewEntry&&(
          <div style={{animation:"fadeIn .3s ease"}}>
            <button onClick={()=>setViewEntry(null)} style={{background:"none",border:"none",color:MUTED,cursor:"pointer",fontSize:12,marginBottom:12,display:"flex",alignItems:"center",gap:5}}>{L.backDiary}</button>
            {viewEntry.photo&&<img src={viewEntry.photo} alt="tea" style={{width:"100%",borderRadius:13,maxHeight:240,objectFit:"cover",marginBottom:13}}/>}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:9}}>
              <div><h2 style={{margin:"0 0 2px",fontWeight:"normal",color:GOLD,fontSize:20}}>{viewEntry.tea}</h2><p style={{margin:0,color:MUTED,fontSize:11}}>{viewEntry.date}{viewEntry.method?` · ${viewEntry.method}`:""}</p></div>
              <span style={{fontSize:17}}>{"⭐".repeat(viewEntry.overall)}</span>
            </div>
            <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:11}}>
              {[viewEntry.color,viewEntry.body,viewEntry.clarity,viewEntry.finish,...(viewEntry.aroma||[]),...(viewEntry.taste||[])].filter(Boolean).map((a,i)=><span key={i} style={{background:i<4?`${GOLD}15`:"rgba(255,255,255,.04)",border:`1px solid ${i<4?GOLD+"28":BORDER}`,color:i<4?GOLD:MUTED,fontSize:10,padding:"2px 9px",borderRadius:9}}>{a}</span>)}
            </div>
            {viewEntry.notes&&<div style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:11,padding:13,marginBottom:11}}><p style={{margin:"0 0 3px",fontSize:9,color:GOLD,letterSpacing:.5}}>{L.tastingNotesLabel}</p><p style={{margin:0,fontSize:12,lineHeight:1.8,color:"#d4c8b0",fontStyle:"italic"}}>{viewEntry.notes}</p></div>}
            <button onClick={()=>{saveDiary(diary.filter(e=>e.id!==viewEntry.id));setViewEntry(null);}} style={{background:"rgba(200,50,50,.08)",border:"1px solid rgba(200,50,50,.18)",color:"#e08080",padding:"8px 16px",borderRadius:16,cursor:"pointer",fontSize:10}}>{L.deleteEntry}</button>
          </div>
        )}

        {/* SUGGEST */}
        {view==="suggest"&&(
          <div style={{animation:"fadeIn .3s ease"}}>
            <h2 style={{margin:"0 0 4px",fontWeight:"normal",color:GOLD}}>{L.suggestTitle}</h2>
            <p style={{margin:"0 0 18px",fontSize:12,color:MUTED}}>{L.suggestSub}</p>

            {suggestStatus==="sent"?(
              <div style={{background:`${GOLD}0C`,border:`1px solid ${GOLD}28`,borderRadius:13,padding:28,textAlign:"center",animation:"fadeIn .4s ease"}}>
                <div style={{fontSize:40,marginBottom:10}}>🍵</div>
                <p style={{margin:0,fontSize:14,color:GOLD}}>{L.sent}</p>
              </div>
            ):(
              <div style={{display:"grid",gap:12}}>
                <div style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:13,padding:16}}>
                  <div style={{display:"grid",gap:11}}>
                    <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.yourName}</label><input value={suggest.name} onChange={e=>setSuggest(s=>({...s,name:e.target.value}))} placeholder={L.namePlaceholder} style={inpS}/></div>
                    <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.teaSuggest} *</label><input value={suggest.tea} onChange={e=>setSuggest(s=>({...s,tea:e.target.value}))} placeholder={L.teaSuggestPlaceholder} style={inpS}/></div>
                    <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.whySuggest}</label><textarea value={suggest.why} onChange={e=>setSuggest(s=>({...s,why:e.target.value}))} placeholder={L.whyPlaceholder} style={{...inpS,minHeight:90,resize:"vertical"}}/></div>
                    <div><label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5}}>{L.yourEmail}</label><input type="email" value={suggest.email} onChange={e=>setSuggest(s=>({...s,email:e.target.value}))} placeholder={L.emailPlaceholder} style={inpS}/></div>
                  </div>
                </div>

                {suggestStatus==="error"&&<p style={{color:"#e08080",fontSize:11,margin:0,textAlign:"center"}}>{L.sendError}</p>}

                <button onClick={sendSuggestion} disabled={suggestStatus==="sending"||!suggest.tea.trim()} style={{background:suggestStatus==="sending"||!suggest.tea.trim()?MUTED:GOLD,border:"none",color:"#12100A",padding:13,borderRadius:11,cursor:suggestStatus==="sending"||!suggest.tea.trim()?"not-allowed":"pointer",fontFamily:"Georgia,serif",fontSize:13,fontWeight:"bold"}}>
                  {suggestStatus==="sending"?L.sending:L.sendSuggestion}
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Bottom nav */}
      <div style={{position:"fixed",bottom:0,left:"50%",transform:"translateX(-50%)",width:"100%",maxWidth:430,background:"rgba(12,9,4,.96)",borderTop:`1px solid ${BORDER}`,display:"flex",backdropFilter:"blur(20px)",zIndex:10}}>
        {nav("home","🍵",L.navTeas)}
        {nav("log","✍️",L.navLog)}
        {nav("diary","📓",L.navDiary)}
        {nav("suggest","💌",L.navSuggest)}
      </div>
    </div>
  );
}
